import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Modules } from '@core/enums/modules.enum';
import { Entities } from '@core/components/entities.enum';
import { RoleTypeKeys } from '@core/enums/role-type-keys.enum';
import { UserService } from '@features/user/services/user.service';
import { NgxPermissionsService } from 'ngx-permissions';
import arrayPath from '@shared/utils/array-path/array-path.utils';
import { Permissions } from '@core/enums/permissions.enum';

@Component({
  selector: 'app-connect-redirect',
  template: '',
})
export class ConnectRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private userService: UserService,
    private ngxPermissionService: NgxPermissionsService,
  ) {}

  public ngOnInit(): void {
    const currentUser = this.userService.getCurrentUser();
    const roleTypeKey = currentUser?.currentRoleType?.key;
    const hasPermission = this.ngxPermissionService.getPermission(
      arrayPath([Modules.ConnectMonitoring, Permissions.Junior, Permissions.Show])
    );

    if (!hasPermission) {
      this.router.navigate([Modules.Connect, Entities.Home]);
      return;
    }

    // Supervisor goes to Juniors, all other roles go to Dashboard
    if (roleTypeKey === RoleTypeKeys.supervisor) {
      this.router.navigate([Modules.Connect, Entities.Juniors]);
    } else {
      this.router.navigate([Modules.Connect, Entities.Dashboard]);
    }
  }
}
